
import storeCode from '~/mixins/storeCode'

export default {
  name: 'ProductPhysicalPrice',

  mixins: [
    storeCode,
  ],

  props: {
    selectedVariantSlug: {
      type: String,
      default: '',
    },

    variants: {
      type: Array,
      default: () => [],
    },

    priceRange: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    priceItems () {
      return this.variants.map(({ slug, price, mediclubPrice, lowestPriceHistory }) => ({ slug, price, mediclubPrice, lowestPriceHistory })) ?? []
    },

    variantPrice () {
      const variantSlug = this.selectedVariantSlug || this.$route.query.variant

      return this.priceItems.find(item => item.slug.toString() === variantSlug) ?? {}
    },

    price () {
      if (this.variants.length === 1) {
        const { finalPrice, price, mediclubPrice, lowestPriceHistory } = this.variants[0]

        return { finalPrice, price, mediclubPrice, lowestPriceHistory }
      }

      const variantSlug = this.selectedVariantSlug || this.$route.query.variant

      const {
        finalPrice = this.priceRange?.minimumFinalPrice,
        price = this.priceRange?.minimumPrice,
        mediclubPrice = this.priceRange?.minimumMediclubPrice,
        lowestPriceHistory = this.priceRange?.lowestPriceHistory,
      } = variantSlug ? this.variantPrice : {}

      return { finalPrice, price, mediclubPrice, lowestPriceHistory }
    },
  },

  watch: {
    price: {
      handler (newVal) {
        this.$emit('price', newVal)
      },

      immediate: true,
    },
  },
}
